import { render, staticRenderFns } from "./QuizAttempt.vue?vue&type=template&id=bc4ad5fa&scoped=true"
import script from "./QuizAttempt.vue?vue&type=script&lang=js"
export * from "./QuizAttempt.vue?vue&type=script&lang=js"
import style0 from "./QuizAttempt.vue?vue&type=style&index=0&id=bc4ad5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ad5fa",
  null
  
)

export default component.exports